import { render, staticRenderFns } from "./DialogoDeConfirmacao.vue?vue&type=template&id=8d66b9da"
import script from "./DialogoDeConfirmacao.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogoDeConfirmacao.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports